export const config = {
	default: 'prod',
	tzh: {
		host: 'https://tzh.markerheadless.info',
		lang: 'hr',
		apiCache: false,
		routeCacheExpire: 0,
	},
	beta: {
		host: 'https://beta.tvornicazdravehrane.com',
		lang: 'hr',
		apiCache: false,
		routeCacheExpire: 0,
	},
	prod: {
		host: 'https://www.tvornicazdravehrane.com',
		lang: 'hr',
		apiCache: true,
		routeCacheExpire: 305,
	},
};
